(() => {
  const popUpButton = document.querySelector('.cart-popup__button');

  window.showCartPopup = function () {
    const cartPopup = document.querySelector('.cart-popup');

    cartPopup.classList.add('cart-popup--active');

    setTimeout(() => {
      window.hideCartPopup();
    }, 3000);
  }

  window.hideCartPopup = function () {
    const cartPopup = document.querySelector('.cart-popup');

    cartPopup.classList.remove('cart-popup--active');
  };

  popUpButton.addEventListener('click', window.hideCartPopup);
})();
